export default __webpack_public_path__ + "static/media/warning.c7a0b4a2.svg";